import { render } from "./purchase-button.vue?vue&type=template&id=610222ce&ts=true"
import script from "./purchase-button.vue?vue&type=script&lang=ts"
export * from "./purchase-button.vue?vue&type=script&lang=ts"

import "./purchase-button.vue?vue&type=style&index=0&id=610222ce&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__